import { Component } from '@angular/core';
import { SettingsActivitiesOption } from 'src/app/enums/settings';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: 'app-settings-activities',
    templateUrl: './settings-activities.component.html',
    styleUrls: ['./settings-activities.component.scss']
})
export class SettingsActivitiesComponent {
    readonly SettingsActivitiesOption = SettingsActivitiesOption;
    selectedComponent!: SettingsActivitiesOption;

    componentMapping: Record<SettingsActivitiesOption, string> = {
        [SettingsActivitiesOption.SITUATIE_CURENTA_COPIL]: 'app-situatie-curenta',
        [SettingsActivitiesOption.GRUP_ATRIBUTE_COPII]: 'app-grup-atribute',
        [SettingsActivitiesOption.ATRIBUTE_COPII]: 'app-atribute-copii',
        [SettingsActivitiesOption.TIPURI_DATE_COPII]: 'app-tipuri-date',
        [SettingsActivitiesOption.STATUS_EVENIMENT_COPIL]: 'app-status-eveniment',
        [SettingsActivitiesOption.PRIORITATE_EVENIMENT_COPIL]: 'app-prioritate-eveniment',
        [SettingsActivitiesOption.ENTITATE_INRUDITA_TYPE]: 'app-entitate-inrudita-type',
        [SettingsActivitiesOption.RELATIE_TYPE]: 'app-relatie-type',
        [SettingsActivitiesOption.CUSTODIE_TYPE]: 'app-custodie-type',
        [SettingsActivitiesOption.RELATIE_STATUS]: 'app-relatie-status',
        [SettingsActivitiesOption.CAPACITATE_CRESTERE_COPIL]: 'app-capacitate-crestere',
        [SettingsActivitiesOption.NIVEL_RISC]: 'app-nivel-risc',
        [SettingsActivitiesOption.STATUS_LEGAL]: 'app-status-legal',
        [SettingsActivitiesOption.CONTACT_FRECVENTA]: 'app-contact-frecventa',
        [SettingsActivitiesOption.PARTEA_RELATIEI]: 'app-partea-relatiei',
        [SettingsActivitiesOption.RELATIE_SPECIFICA_SEX]: 'app-relatie-specifica',
        [SettingsActivitiesOption.CONFIRMARE_RELATIE]: 'app-confirmare-relatie',
        [SettingsActivitiesOption.ADRESE_CENTRE]: 'app-adrese-centre',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.SITUATIE_CURENTA_COPIL
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.GRUP_ATRIBUTE_COPII
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.ATRIBUTE_COPII
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.TIPURI_DATE_COPII
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.STATUS_EVENIMENT_COPIL
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.PRIORITATE_EVENIMENT_COPIL
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.ENTITATE_INRUDITA_TYPE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.RELATIE_TYPE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.CUSTODIE_TYPE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.RELATIE_STATUS
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.CAPACITATE_CRESTERE_COPIL
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.NIVEL_RISC
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.STATUS_LEGAL
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.CONTACT_FRECVENTA
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.PARTEA_RELATIEI
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.RELATIE_SPECIFICA_SEX
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.CONFIRMARE_RELATIE
        //     );
        // }
        // if (!this.permissionsService.hasPermission('dgaspc.settings.status-programare.list')) {
        //     this.componentKeys = this.componentKeys.filter(
        //         (item) => item !== SettingsActivitiesOption.ADRESE_CENTRE
        //     );
        // }
    }
}
